import { API_URL } from "@/config";

export function imageUrl(media_url: string) {
  const url = new URL(media_url, API_URL);
  return url.toString();
}
